import { render, staticRenderFns } from "./WebsiteFooter.vue?vue&type=template&id=26202a1e&scoped=true"
import script from "./WebsiteFooter.vue?vue&type=script&lang=js"
export * from "./WebsiteFooter.vue?vue&type=script&lang=js"
import style0 from "./WebsiteFooter.vue?vue&type=style&index=0&id=26202a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26202a1e",
  null
  
)

export default component.exports